import React, { useState, useEffect } from 'react';
import { Button, Text, Small, Panel, H3, H4, Dropdown, Input, Tabs, Datepicker, Textarea, Box, Select } from '@bigcommerce/big-design';

const ToteGrid = ({ label, description, rows, columns, content, setContentText, allowUpdates, highlightCells, secondaryHighlightCells }) => {
  return(
    <Panel className="full-width feature-card-margins">
      { label && <><H3>{ label }</H3><hr/></> }
      { description && <><Small>{ description }</Small><br/></>}

      <table className="full-width tote-grid">
        <thead></thead>
        <tbody>
          { [...Array(rows)].map((row, rowIndex) => 
            <tr className="tote-grid">
              { [...Array(columns)].map((column, columnIndex) => 
                <td
                  className="tote-grid"
                  style={{ 'background': `${(highlightCells?.[rowIndex]?.[columnIndex] && '#5bc6cc') || (secondaryHighlightCells?.[rowIndex]?.[columnIndex] && '#ef8f2f') }` }}
                >
                  { allowUpdates &&
                    <Input 
                      required 
                      label=""
                      placeholder="Not set"
                      id={`r${rowIndex}_c${columnIndex}`}
                      type="text" 
                      value={content?.[rowIndex]?.[columnIndex]} 
                      onChange={(e) => setContentText(rowIndex, columnIndex, e)} 
                    />
                  }

                </td>
                )
              }
              
            </tr>
            )
          }
        </tbody>
      </table>
    </Panel>
  )

}

export default ToteGrid;